import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const HowToBuy = () => {
    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    return (
        <div className='bg-gray-50 md:p-4 font-poppins'>
            <h2 className=" text-xl md:text-2xl font-semibold md:font-extrabold">
                {translate ?
                    "How to buy products at Dear Perfume?"
                    :
                    "ডিয়ার পারফিউম এ কিভাবে পণ্য কিনবেন?"
                } </h2>

            <p className="md:pl-2 my-2">
                {translate ?
                    "Deerparfum.com is the bridge of your choice and need so visit now and order anytime from anywhere and the product will reach you on time. You can shop at deerparfum using your computer, laptop or smartphone."
                    :
                    "Deerparfum.com আপনার পছন্দ আর প্রয়োজনের সেতুবন্ধন তাই এখই ভিজিট করুন  আর অর্ডার করুন যেকোন সময়ে যেকোন স্থান থেকেএবং পণ্য ঠিক সময়ে পৌছে যাবে আপনার হাতে। deerparfum এ শপিং করতে পারেন আপনার কম্পিউটার, ল্যাপটপ অথবা স্মার্টফোন ব্যবহার করে ।"
                }

            </p>

            <h3 className="text-xl font-semibold">

                {translate ?
                    "Shop at Dear Perfume and stand out from the rest."
                    :
                    "শপিং করুন ডিয়ার পারফিউম এ আর হয়ে উঠুন অন্য সবার চেয়ে আলাদা।"
                }
            </h3>

            <ul className="pt-3">
                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "1"
                            :
                            "১"
                        }
                    </span>
                    {translate ?
                        "You can shop at Dear Perfume using the internet on your computer, laptop and smartphone. Type deerparfum.com in your browser and press enter."
                        :
                        "ডিয়ার পাারফিউম এ শপিং করতে পারেন আপনার কম্পিউটার, ল্যাপটপ স্মার্টফোনে ইন্টারনেট ব্যবহার করে । আপনার ব্রাউজারের deerparfum.com লিখে ইন্টার চাপুন ব্যস।"
                    }
                </li>

                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "2"
                            :
                            "২"
                        }
                    </span>
                    {translate ?
                        "To buy your selected product, click on the product image and go to the offer details page and click on the 'Add to Cart' button next to the image."
                        :
                        "আপনার নির্বাচিত পন্যটি কেনার জন্য পণ্যের ছবির উপরে ক্লিক করে অফারটির বিস্তারিত পাতায় গিয়ে ছবির পাশে ‘Add to Cart/কার্টে যোগ করুন’ এই বাটনে ক্লিক করুন।"
                    }
                </li>

                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "3"
                            :
                            "৩"
                        }
                    </span>
                    {translate ?
                        "If you want to buy more than one product, click the 'Add to Cart' button to order all your selected products at once."
                        :
                        "আপনি যদি একাধিক পন্য কিনতে চান তাহলে ‘কার্ট এ যোগ করুন’ এই বাটনে ক্লিক করে আপনার নির্বাচিত সকল পন্য একবারে অর্ডার করুন।"
                    }
                </li>

                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "4"
                            :
                            "৪"
                        }
                    </span>
                    {translate ?
                        "If you already have an account on dearperfume.com, then sign in / login with your username and password or create a username and password for your new account by signing up / registering as a new customer."
                        :
                        "যদি ইতোমধ্যেই ডিয়ারপারফিউম.কম এ আপনার একাউন্ট থেকে থাকে,তাহলে আপনার ইউজার নেম ও পাসওয়ার্ড দিয়ে সাইন ইন / লগইন করুন অথবা নতুন ক্রেতা হিসেবে সাইন-আপ/রেজিস্ট্রেশন করে আপনার নতুন একাউন্টের জন্য ইউজার নেম ও পাসওয়ার্ড তৈরি করুন।"
                    }
                </li>

                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "5"
                            :
                            "৫"
                        }
                    </span>
                    {translate ?
                        "Correctly provide the information requested in the 'Delivery and Payment Process' section while placing the order. Remember that accurate information provided by you will speed up the delivery process of your product."
                        :
                        "অর্ডার করার সময় ‘ডেলিভারী ও মুল্য পরিশোধ প্রক্রিয়া’ অংশে যে যে তথ্য চাওয়া হয়েছে সেগুলো সঠিকভাবে প্রদান করুন। মনে রাখবেন আপনার প্রদানকৃত সঠিক তথ্য আপনার পন্যের ডেলিভারী প্রক্রিয়াকে ত্বরান্বিত করবে।"
                    }
                </li>

                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "6"
                            :
                            "৬"
                        }
                    </span>
                    {translate ?
                        "Then you click on the 'Next Step' button to go to the next step."
                        :
                        "এরপরে আপনি পরবর্তী ধাপে যেতে ‘পরবর্তী ধাপ’ বাটনে ক্লিক করুন।"
                    }
                </li>

                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "7"
                            :
                            "৭"
                        }
                    </span>
                    {translate ?
                        "Go to the next step and recheck your order summary."
                        :
                        "পরবর্তী ধাপে গিয়ে আপনার অর্ডারটির সার-সংক্ষেপ পুনরায় চেক করুন ।"
                    }
                </li>

                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "8"
                            :
                            "৮"
                        }
                    </span>
                    {translate ?
                        "If everything is correct click 'Confirm'."
                        :
                        "সব কিছু সঠিক থাকলে ‘কনফার্ম করুন’।"
                    }
                </li>

                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "9"
                            :
                            "৯"
                        }
                    </span>
                    {translate ?
                        "Our representative will contact you by phone within 24 hours."
                        :
                        "২৪ ঘণ্টার মধ্যে আমাদের প্রতিনিধি আপনার সাথে ফোনে যোগাযোগ করবে।"
                    }
                </li>

                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "10"
                            :
                            "১০"
                        }
                    </span>
                    {translate ?
                        "For any information assistance call –+8801841 282920 (between 8 am to 11 pm)."
                        :
                        "যেকোন তথ্য সহায়তার জন্য ফোন করুন –+8801841 282920 (সকাল 8টা থেকে রাত ১১ টার মধ্যে)।"
                    }
                </li>

                <li className="text-body-color mb-4 flex text-base">
                    <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                        <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                        {translate ?
                            "11"
                            :
                            "১১"
                        }
                    </span>
                    {translate ?
                        "Wishlist allows you to select different orders that you can purchase later."
                        :
                        "ইচ্ছেলিস্ট এর মাধ্যমে আপনি বিভিন্ন অর্ডার নির্বাচিত করে রাখতে পারবেন যা আপনি পরবর্তীতে কিনতে পারেন।"
                    }
                </li>
            </ul>
        </div>
    );
};

export default HowToBuy;